import { adaptToDatabase } from '../../../utils/adaptToDatabase'
import apinode from '../../apinode'

class ReclamacoesService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll({ status, cliente }) {
    let url = `/claims/${this.idconta}`

    if (status) {
      url += `?status=${status}`

      if (cliente) {
        url += `&cliente=${cliente}`
      }
    } else if (cliente) {
      url += `?cliente=${cliente}`
    }

    const response = await apinode.get(url)

    return response.data
  }

  async getByCode(code) {
    const response = await apinode.get(`/claims/${code}/${this.idconta}`)

    return response.data
  }

  async getByOrderId(pedido) {
    const response = await apinode.get(
      `/claims/pedido/${pedido}/${this.idconta}`,
    )

    return response.data
  }

  async getStatus() {
    const response = await apinode.get(`/claims/get_status/${this.idconta}`)

    return response.data.status
  }

  async sync() {
    await apinode.patch(`/claims/sync/${this.idconta}`)
  }

  async create(data) {
    const dataFormatted = adaptToDatabase(data, [
      'taxa_envio',
      'taxa_retorno',
      'debito_ml',
      'credito_ml',
    ])

    await apinode.post(`/claims/${this.idconta}`, dataFormatted)
  }

  async update(id, data) {
    const dataFormatted = adaptToDatabase(data, [
      'taxa_envio',
      'taxa_retorno',
      'debito_ml',
      'credito_ml',
    ])

    await apinode.put(`/claims/${id}/${this.idconta}`, dataFormatted)
  }

  async delete(code) {
    await apinode.delete(`/claims/${code}/${this.idconta}`)
  }
}

export default new ReclamacoesService()
